<ng-container *transloco="let t">
  <h2 mat-dialog-title>
    {{ t('LANGUAGE_SELECTION.SELECT_PREFERRED_LANGUAGE') }}
  </h2>
  <mat-dialog-content>
    <div class="sections-wrapper">
      <mat-form-field>
        <mat-label>{{ t('LANGUAGE_SELECTION.APP_LANGUAGE') }}</mat-label>
        <mat-select [formControl]="appLangControl">
          @for (language of availableLanguages; track $index) {
            <mat-option [value]="language.id">
              <img
                [src]="'assets/images/flags/' + language.flag + '.png'"
                [alt]="language.title"
              />
              {{ language.title }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (sessionRepo.isLoggedIn$ | async) {
        <mat-form-field>
          <mat-label>{{ t('LANGUAGE_SELECTION.COMM_LANGUAGE') }}</mat-label>
          <mat-select [formControl]="emailLangControl">
            @for (language of availableLanguages; track $index) {
              <mat-option [value]="language.id">
                <img
                  [src]="'assets/images/flags/' + language.flag + '.png'"
                  [alt]="language.title"
                />
                {{ language.title }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ t('GENERAL.OK') }}</button>
  </mat-dialog-actions>
</ng-container>
